import * as React from 'react';
import { Skeleton } from '../ui/skeleton.js';

export function MemoraiSkeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
    return <Skeleton className={className} {...props} />;
}
